import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('User => ');

const fetchCurrentUser = createAction('fetch current user');
const fetchCurrentUserSuccess = createAction('fetch current user success', user => ({ user }));
const fetchCurrentUserFailure = createApiFailureAction('fetch current user failure');

export default {
  fetchCurrentUser,
  fetchCurrentUserSuccess,
  fetchCurrentUserFailure,
};
